import { useQuery } from "@tanstack/react-query"
import { Tables } from "@/integrations/supabase/types"
import { useAuth } from "./useAuth"
import { supabase } from "@/integrations/supabase/client"

type Unit = Tables<"units">
type Profile = Tables<"profiles">
type UnitDetails = Tables<"unit_details">

type UnitWithOwnerAndDetails = Unit & {
  owner: Profile | null
  tenant: Profile | null
  unit_details: UnitDetails | null
}

export const useUnits = () => {
  const { profile } = useAuth()
  
  return useQuery({
    queryKey: ["units", profile?.condominium_id],
    queryFn: async () => {
      if (!profile?.condominium_id) return []

      console.log('Carregando unidades do Supabase para condomínio:', profile.condominium_id)
      const { data: remoteData, error } = await supabase
        .from("units")
        .select("*")
        .eq("condominium_id", profile.condominium_id)

      if (error) {
        console.error("Erro ao carregar unidades:", error)
        throw error
      }
      const data = remoteData || []

      // Mapeia para corresponder ao tipo UnitWithOwnerAndDetails esperado pelo frontend
      const mappedData = data.map(u => ({
        ...u,
        owner: null,
        tenant: null,
        unit_details: null
      }))

      // Ordenação numérica inteligente no frontend
      const sortedData = mappedData.sort((a, b) => {
        // Primeiro ordena por bloco/prédio
        if (a.building && b.building && a.building !== b.building) {
          return a.building.localeCompare(b.building)
        }
        
        // Depois ordena numericamente pelo número da unidade
        const numA = parseInt(a.number) || 0
        const numB = parseInt(b.number) || 0
        return numA - numB
      })
      
      console.log('Unidades carregadas localmente:', sortedData.length)
      return sortedData as UnitWithOwnerAndDetails[]
    },
    enabled: !!profile?.condominium_id
  })
}
